import { graphql } from "../../generated";
export const MUTATE_LOCK_THREAD = graphql(`
  mutation MutateLockThread($id: Int!) {
    lockThread(id: $id)
  }
`);
